var _circle, _rect, _path, _rect2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNonprofitOrganizations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FDF3E7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 22,
    width: 5,
    height: 14,
    rx: 0.5,
    fill: "#FD904D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 24.5a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-11z",
    fill: "#FD904D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 5,
    height: 14,
    rx: 0.5,
    fill: "#FD904D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24.5a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-11zM12 14h20v-2l4 4-4 4v-2H12v-4z",
    fill: "#FD904D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNGREYzRTciLz4KPHJlY3QgeD0iMTIiIHk9IjIyIiB3aWR0aD0iNSIgaGVpZ2h0PSIxNCIgcng9IjAuNSIgZmlsbD0iI0ZEOTA0RCIvPgo8cGF0aCBkPSJNMTggMjQuNUMxOCAyNC4yMjM5IDE4LjIyMzkgMjQgMTguNSAyNEgyMi41QzIyLjc3NjEgMjQgMjMgMjQuMjIzOSAyMyAyNC41VjM1LjVDMjMgMzUuNzc2MSAyMi43NzYxIDM2IDIyLjUgMzZIMTguNUMxOC4yMjM5IDM2IDE4IDM1Ljc3NjEgMTggMzUuNVYyNC41WiIgZmlsbD0iI0ZEOTA0RCIvPgo8cmVjdCB4PSIyNCIgeT0iMjIiIHdpZHRoPSI1IiBoZWlnaHQ9IjE0IiByeD0iMC41IiBmaWxsPSIjRkQ5MDREIi8+CjxwYXRoIGQ9Ik0zMCAyNC41QzMwIDI0LjIyMzkgMzAuMjIzOSAyNCAzMC41IDI0SDM0LjVDMzQuNzc2MSAyNCAzNSAyNC4yMjM5IDM1IDI0LjVWMzUuNUMzNSAzNS43NzYxIDM0Ljc3NjEgMzYgMzQuNSAzNkgzMC41QzMwLjIyMzkgMzYgMzAgMzUuNzc2MSAzMCAzNS41VjI0LjVaIiBmaWxsPSIjRkQ5MDREIi8+CjxwYXRoIGQ9Ik0xMiAxNEgzMlYxMkwzNiAxNkwzMiAyMFYxOEgxMlYxNFoiIGZpbGw9IiNGRDkwNEQiLz4KPC9zdmc+Cg==";
export { SvgNonprofitOrganizations as ReactComponent };